/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360BusinessLogicInventoryModelsProductLink {
    /**
     * 1 = Video, 2 = Document, 3 = Website, 100 = Facebook, 101 = Twitter, 102 = Instagram, 103 = Pinterest
     */
    Type?: Open360BusinessLogicInventoryModelsProductLink.TypeEnum;
    Title?: string;
    Url?: string;
}
export namespace Open360BusinessLogicInventoryModelsProductLink {
    export type TypeEnum = 1 | 2 | 3 | 100 | 101 | 102 | 103;
    export const TypeEnum = {
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum,
        NUMBER_3: 3 as TypeEnum,
        NUMBER_100: 100 as TypeEnum,
        NUMBER_101: 101 as TypeEnum,
        NUMBER_102: 102 as TypeEnum,
        NUMBER_103: 103 as TypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicInventoryModelsProductLink.ts